import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { connect, ConnectedProps } from 'react-redux'

import fieldsService from '../../services/fields.service';

import {
    IChoiceField,
    IField,
    IProtocol,
    IVisibilita,
    ISearchTableState
} from '../../shared/interfaces';
import {
    IUserInfoDTO,
    ISearchFilter,
    ISearchCriteria,
    ISearchPageResult,
    SearchFilterNames
} from '../../shared/interfacesDTO';

import abilityBuild from '../../shared/CASL/appAbility';
import { subject, Unsubscribe } from '@casl/ability';

import {
    Selection, CommandBar, DefaultButton, DetailsHeader, IBasePickerSuggestionsProps,
    DetailsList, Text, DetailsListLayoutMode, IButtonProps, IColumn, ICommandBarItemProps, ICommandBarStyles, IDetailsListStyles,
    Label, Link, mergeStyleSets, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, TagPicker,
    ITag, IBasePicker, SearchBox, Icon, CheckboxVisibility, SelectionMode, IDetailsList, IDetailsColumnStyles, TooltipHost,
    IContextualMenuItem, ContextualMenu, IDropdownOption, Dropdown, IconButton, ITooltipHostStyles, TooltipOverflowMode,
    IRenderFunction, IDetailsColumnFieldProps, ISearchBoxStyles
} from '@fluentui/react';
import { reduxActions, RootState } from '../../store';

import CircleLoader from '../Loader/CircleLoader/CircleLoader';
import CustomCommandBarMenuItem from '../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';

import { Indici_FormMode, Protocol_State, RoleContext, Visibility_Type, Visibility_Type_Label } from '../../shared/enums';


import DynamicForm from '../DynamicForm/DynamicForm';
import { checkRoles } from '../../hoc/CheckRoles';
import searchService from '../../services/search.service';
import AppUtilities from '../../shared/Utilities/appUtilities';
import uorsService from '../../services/uors.service';
import axios, { CancelTokenSource } from 'axios';
import CustomCommandBarButton from '../CustomFluentUI/CustomCommandBarButton/CustomCommandBarButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import protocolsService from '../../services/protocols.service';
import { toastRef } from '../Layout/Layout';
import Utilities from '../../shared/Utilities/utilities';
import { SessionState } from '../../store/session/types';
import TableIconProprietario from '../../sharedComponents/TableIconProprietario';
import TableIconInoltro from '../../sharedComponents/TableIconInoltro';
import TableIconCopiaConoscenza from '../../sharedComponents/TableIconCopiaConoscenza';
import TableIconVisibilita from '../../sharedComponents/TableIconVisibilita';
import SummaryIACallout from '../../sharedComponents/SummaryIACallout';

const queryString = require('query-string');

const classNames = mergeStyleSets({
    fileIconHeaderIcon: {
        padding: 0,
        fontSize: '16px',
    },
    fileIconCell: {
        textAlign: 'center',
        selectors: {
            '&:before': {
                content: '.',
                display: 'inline-block',
                verticalAlign: 'middle',
                height: '100%',
                width: '0px',
                visibility: 'hidden',
            },
        },
    },
    fileIconImg: {
        verticalAlign: 'middle',
        maxHeight: '16px',
        maxWidth: '16px',
    },
    controlWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    exampleToggle: {
        display: 'inline-block',
        marginBottom: '10px',
        marginRight: '30px',
    },
    selectionDetails: {
        marginBottom: '20px',
    },
    iconField: {
        padding: '5px',
        width: '28px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    iconFieldHeader: {
        padding: 0,
        fontSize: '16px',
    },

    emptyColumn: {

    }
});

const globalSearchBoxStyles: Partial<ISearchBoxStyles> = { root: { width: 400, 'border-color': '#9f9f9f' } };


const tooltipHostStyles: Partial<ITooltipHostStyles> = {
    root: {
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'

    }
};

const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};

const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee', borderTop: '1px solid #eee' },
    primarySet: {
        '& .ms-OverflowSet-item:first-of-type': {
            display: 'flex', flexFlow: 'column', justifyContent: 'center', padding: '4px'
        },
    },
    secondarySet: {
        '& .ms-OverflowSet-item': {
            display: 'flex', flexFlow: 'row', justifyContent: 'center', padding: '4px'
        }
    }
};

const detailsListStyles: Partial<IDetailsListStyles> = {
    root: {
        overflow: 'visible'
    }
}

const iconHeaderStyles: Partial<IDetailsColumnStyles> = {
    root: {
        width: '28px !important',
        padding: 0
    },
    cellTitle: {
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0
    }

}
//const lastIconHeaderStyles: Partial<IDetailsColumnStyles> = {
//    root: {
//        width: '28px !important',
//        padding: 0
//    },
//    cellTitle: {
//        alignItems: 'center',
//        justifyContent: 'center',
//        padding: 0
//    }

//}

const tagPickerSuggestionsProps: IBasePickerSuggestionsProps = {
    suggestionsHeaderText: 'Suggerimenti',
    mostRecentlyUsedHeaderText: 'Utenti suggeriti',
    noResultsFoundText: 'Nessun risultato trovato',
    loadingText: 'Caricamento',
    showRemoveButtons: false,
};


const mapState = (state: RootState) => ({
    currentUser: state.sessionReducer.currentUser,
    currentAoo: state.sessionReducer.currentAoo,
    allRoles: state.sessionReducer.allRoles,
    tuttiIProtocolliViewFields: state.sessionReducer.tuttiIProtocolliViewFields,
    campiRicercaViewFields: state.sessionReducer.campiRicercaViewFields,
    features: state.sessionReducer.features,
    isMobile: state.sessionReducer.isMobile,
    protocolsTableState: state.appNavigationReducer.searchTableState
})

const mapDispatch = {
    setProtocolsTableState: (protocolsTableState: (ISearchTableState)) => (reduxActions.appNavigationActions.setProtocolsTableState(protocolsTableState)),
    unsetProtocolsTableState: () => (reduxActions.appNavigationActions.unsetProtocolsTableState()),
    setProtocol: (protocol: IProtocol) => (reduxActions.appNavigationActions.setProtocol(protocol)),
    updateSession: (sessionState: Partial<SessionState>) => (reduxActions.sessionActions.updateSession(sessionState)),
}

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>

export interface SearchComponentBaseState {
    columns: IColumn[];
    items: (IProtocol | null)[];
    totalRows: number;
    searchResultMessage: string;
    selectedProtocols: IProtocol[]

    commandBarItems: ICommandBarItemProps[];
    farItems: ICommandBarItemProps[];

    isLoadingProtocols: boolean;

    searchFormFields: IField[];
    uorField: Partial<IField>;
    visibilitaField: Partial<IChoiceField>;
    searchPanelIsOpen: boolean;
    searchRequest: ISearchCriteria;

    summaryIA: string | undefined
    summaryIAisLoading: boolean
    summaryIACalloutIsOpen: boolean;
    summaryIACalloutTargetId: string | undefined

    showContextualMenu: boolean
    contextMenuItems: IContextualMenuItem[] | undefined
    contextMenuPosition: any

    messageBarIsVisible: boolean;
    messageBarType: MessageBarType | undefined;
    messageBarText: string;

}
export interface SearchComponentBaseProps {
    //    protocolsTableState?: Partial<IProtocolsTableState>
    //    updateProtocolsTableState?: (protocolsTableState: Partial<IProtocolsTableState>) => void
    //    searchBaseWillUnmount?: () => void
}

type Props = SearchComponentBaseProps & RouteComponentProps & PropsFromRedux

class SearchComponentBase extends React.Component<Props, SearchComponentBaseState> {

    tagPickerRef = React.createRef<IBasePicker<ITag>>();
    detailsListRef = React.createRef<IDetailsList>();
    cancelTokenSources = {};
    unsubscribeFromAbility: Unsubscribe = () => { };
    private protocolSelection: Selection;
    private readonly EMPTY_VALUE = "-";
    private readonly hiddenProtocolCreationStates: string[] = [
        Protocol_State.InCreazione,
        Protocol_State.InCreazioneDaMail,
        'In creazione',
        'In creazione da Mail',
        'In creazione da mail'
    ];

    constructor(props) {
        super(props);

        this.protocolSelection = new Selection({
            onSelectionChanged: () => {
                const selection = this.protocolSelection.getSelection() as IProtocol[];
                this.setState({ selectedProtocols: selection });
            },
        });


        this.state = {
            columns: [],
            items: [],
            totalRows: 0,
            searchResultMessage: '',
            selectedProtocols: [],

            commandBarItems: [],
            farItems: [],

            isLoadingProtocols: true,

            searchFormFields: [],
            uorField: {
                displayName: "Uor",
                internalName: "uor",
                controlType: "autocomplete",
                required: false,
                readonly: false,
                disabled: false,
                system: false,
                internalValue: '',
                valid: false,
                touched: false,

            },
            visibilitaField: {
                displayName: "Tipo visibilità",
                internalName: "visibilityType",
                controlType: "dropdown",
                required: false,
                readonly: false,
                disabled: false,
                system: false,
                valid: false,
                touched: false,
                multi: false,
                options: [
                    { text: Visibility_Type_Label.get(Visibility_Type.Proprietario), key: Visibility_Type.Proprietario },
                    { text: Visibility_Type_Label.get(Visibility_Type.Inoltro), key: Visibility_Type.Inoltro },
                    { text: "Visibilit\u00e0", key: Visibility_Type.Visibilita },
                    { text: Visibility_Type_Label.get(Visibility_Type.CopiaConoscenza), key: Visibility_Type.CopiaConoscenza },
                ] as IDropdownOption[]
            },
            searchPanelIsOpen: false,
            searchRequest: {
                filters: [],
                sorts: [],
                pageNumber: 1,
                globalSearch: undefined
            } as ISearchCriteria,

            summaryIA: undefined,
            summaryIAisLoading: false,
            summaryIACalloutIsOpen: false,
            summaryIACalloutTargetId: undefined,

            showContextualMenu: false,
            contextMenuItems: [],
            contextMenuPosition: undefined,

            messageBarIsVisible: false,
            messageBarType: undefined,
            messageBarText: '',

        };
    }
    componentDidMount() {
        this.updateCommandBarItems();
        // Mi sottoscrivo all'aggiornamento dell'ability: se le colonne sono state costruite/rimappate
        // prima che l'ability fosse pronta, la colonna hasSummaryIAIcon potrebbe mancare.
        // In quel caso la ricostruisco senza alterare il resto del flusso.
        this.unsubscribeFromAbility = abilityBuild.on('updated', this.ensureSummaryIAColumn);
        //se non ho columns significa che lo stato salvato è parziale (es. switch pagina prima della response)
        if (this.props.protocolsTableState && this.props.protocolsTableState.columns && this.props.protocolsTableState.columns.length > 0) {
            this.restoreReduxState();
        }
        else if (this.props.currentAoo && this.props.tuttiIProtocolliViewFields) {
            let { searchFormFields } = this.state;
            let columns = this.setColumns();
            this.setState({
                columns,
                searchFormFields: this.removeHiddenProtocolCreationStates(
                    this.props.campiRicercaViewFields ?? searchFormFields
                )
            }, () => {
                this.getProtocols();
            });
        }
        if (!this.props.campiRicercaViewFields) {
            this.getSearchFormFields();
        }
    }

    componentDidUpdate(oldProps, oldstate: SearchComponentBaseState) {
        // se cambia aoo sicuramente non devo ricaricare lo stato da redux
        if ((oldProps.currentAoo !== this.props.currentAoo && this.props.tuttiIProtocolliViewFields)
            || (this.props.currentAoo && !oldProps.tuttiIProtocolliViewFields && this.props.tuttiIProtocolliViewFields)) {

            if (this.props.tuttiIProtocolliViewFields.length > 0) {
                let columns = this.setColumns();

                let currentSearchRequest: ISearchCriteria = {
                    ...this.state.searchRequest,
                    pageNumber: 1
                };

                this.setState({
                    items: [],
                    columns,
                    searchRequest: currentSearchRequest,
                }, () => {
                    this.getProtocols();
                });
            }
            else {
                this.setState({ isLoadingProtocols: false });
            }
        }
        if (oldstate.searchRequest !== this.state.searchRequest || oldstate.selectedProtocols !== this.state.selectedProtocols) {
            this.updateCommandBarItems();
        }


    }

    componentWillUnmount() {
        this.saveReduxState();
        this.unsubscribeFromAbility();
        // cancello tutte le request in pending
        for (const [key, value] of Object.entries<CancelTokenSource>(this.cancelTokenSources)) {
            value.cancel(`${key} canceled`)
        }
        //this.saveScrollPosition();

    }

    // Garantisce la presenza della colonna hasSummaryIAIcon quando l'ability viene aggiornata
    // dopo la costruzione/rimappatura iniziale delle colonne.
    ensureSummaryIAColumn = () => {
        const canUseIA = abilityBuild.can('use', subject('IFeature', { key: 'IAAssistant', enabled: true }));
        const hasColumn = this.state.columns.some((col: IColumn) => col.key === 'hasSummaryIAIcon');
        if (canUseIA && !hasColumn && this.props.tuttiIProtocolliViewFields && this.props.tuttiIProtocolliViewFields.length > 0) {
            this.setState({ columns: this.setColumns() });
        }
    }

    getProtocols = () => {
        if (this.props.currentAoo) {
            this.cancelTokenSources[searchService.search.name]?.cancel("Request annullata");
            this.cancelTokenSources[searchService.search.name] = axios.CancelToken.source();

            this.setState({ isLoadingProtocols: true });

            const { searchRequest, totalRows, uorField } = this.state;

            searchService
                .search(this.props.currentAoo.id, searchRequest, this.cancelTokenSources[searchService.search.name].token)
                .then((result: ISearchPageResult<IProtocol>) => {
                    const pageItems = result.items ?? [];
                    const newTotalRows = result.totalCount ?? totalRows;

                    const currentItems = this.removeNullPlaceholders(this.state.items);
                    const mergedItems: (IProtocol | null)[] = [...currentItems, ...pageItems];
                    const nextPageNumber = searchRequest.pageNumber + 1;

                    if (mergedItems.length < (newTotalRows ?? 0)) {
                        mergedItems.push(null);
                    }




                    var searchMessage;
                    var uorInSearchMessage = uorField.internalValue.length === 1 ? uorField.internalValue[0].name : undefined;
                    if (this.state.searchRequest?.globalSearch || (this.state.searchRequest?.filters && this.state.searchRequest?.filters.length > 0)) {
                        searchMessage = newTotalRows === 1 ? 'La ricerca ha prodotto 1 risultato' : `La ricerca ha prodotto ${newTotalRows} risultati`;
                        if (uorField.internalValue.length > 0) {
                            searchMessage += ` per ${uorInSearchMessage}`;
                        }
                    }



                    this.setState(prevState => ({
                        items: mergedItems,
                        searchRequest: {
                            ...prevState.searchRequest,
                            pageNumber: nextPageNumber
                        },
                        isLoadingProtocols: false,
                        totalRows: newTotalRows ?? 0,
                        searchResultMessage: searchMessage ?? ''
                    }), () => { this.saveReduxState(); });
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        console.log(error.message);
                    }

                    this.setState({
                        items: [],
                        totalRows: 0,
                        isLoadingProtocols: false
                    }, () => { this.saveReduxState(); });
                });
        }
    }

    saveReduxState = () => {
        let startItemIndexInView = this.detailsListRef.current?.getStartItemIndexInView() ?? 0;

        let protocolsTableState: ISearchTableState = {
            startItemIndexInView: startItemIndexInView,
            columns: [...this.state.columns],
            items: this.state.items && this.state.items.length > 0 ? [...this.state.items] : [],
            searchRequest: { ...this.state.searchRequest },
            searchFormFields: [...this.state.searchFormFields],
            uorField: { ...this.state.uorField },
            visibilitaField: { ...this.state.visibilitaField },
            totalRows: this.state.totalRows,
            searchResultMessage: this.state.searchResultMessage
        };

        this.props.setProtocolsTableState({ ...protocolsTableState });
    }




    restoreReduxState = () => {

        if (this.props.protocolsTableState && this.props.protocolsTableState.columns && this.props.protocolsTableState.columns.length > 0) {
            let storedState = { ...this.props.protocolsTableState }

            this.setState({
                columns: this.remapColumns([...storedState.columns]),
                items: [...storedState.items],
                searchRequest: { ...storedState.searchRequest },
                searchFormFields: this.removeHiddenProtocolCreationStates([...storedState.searchFormFields]),
                uorField: { ...storedState.uorField },
                visibilitaField: { ...storedState.visibilitaField },
                totalRows: storedState.totalRows,
                searchResultMessage: storedState.searchResultMessage,
                isLoadingProtocols: false
            }, () => {
                setTimeout(() => {
                    this.detailsListRef.current?.focusIndex(storedState.startItemIndexInView ?? 0);
                    this.updateCommandBarItems();
                }, 100);
            })

            if (!storedState.searchFormFields || storedState.searchFormFields.length === 0) {
                this.getSearchFormFields();
            }
        }
    }

    updateCommandBarItems = () => {
        let { currentUser, match } = this.props;
        let aooId: number = Number(match.params['aooId']);

        let newCommandBarItems: ICommandBarItemProps[] = [];
        let newFarBarItems: ICommandBarItemProps[] = [];

        newCommandBarItems.push(
            {
                key: 'filtri',
                commandBarButtonAs: () => (

                    <CustomCommandBarButton
                        asDefaultButton={true}
                        text='Filtri'
                        key='Filtri'
                        iconPropsFontAwesome={{ icon: ['far', 'filter'] }}
                        onClick={this.openSearchPanel}
                    />

                )
            }
        );
        newCommandBarItems.push(
            {
                key: 'aggiornaProtocolli',
                text: 'Aggiorna',
                iconProps: { iconName: 'Refresh' },
                onClick: this.onAggiornaProtocolliClick
            },
        );



        if (this.state.searchRequest?.globalSearch || (this.state.searchRequest?.filters && this.state.searchRequest?.filters.length > 0)) {
            newCommandBarItems.push({
                key: 'resetFiltri',
                commandBarButtonAs: () => (
                    <CustomCommandBarButton
                        text='Reset filtri'
                        key='resetFiltri'
                        iconPropsFontAwesome={{ icon: ['fal', 'filter-slash'] }}
                        onClick={this.resetSearchHandler}
                    />
                )
            });
        }

        let { selectedProtocols } = this.state;
        let selectedSingleProtocolAreaDiLavoro: IProtocol | undefined = selectedProtocols.length === 1 ? selectedProtocols[0] : undefined;
        if (selectedSingleProtocolAreaDiLavoro) {
            if (selectedSingleProtocolAreaDiLavoro.hasAttachments) {
                newCommandBarItems.push({
                    key: 'downloadDocument',
                    text: 'Scarica',
                    iconProps: { iconName: 'DownloadDocument' },
                    split: true,
                    onClick: this.onDownloadProtocolDocumentClick,
                    subMenuProps: {
                        items: [
                            {
                                key: 'downloadAll',
                                text: 'Scarica tutto',
                                iconProps: { iconName: 'Download' },
                                onClick: this.onDownloadAllButtonClick
                            },
                        ],
                    }

                });

            }
            else {
                newCommandBarItems.push({
                    key: 'downloadDocument',
                    text: 'Scarica',
                    iconProps: { iconName: 'DownloadDocument' },
                    onClick: this.onDownloadProtocolDocumentClick
                });
            }


            // ricavo le uor in cui l'utente corrente ha ruolo Operatore
            const uorIdWhereUserIsOperatore = currentUser?.ruoliUorContext.reduce((a: number[], o) => (o.aooId === aooId && o.ruoloNome === "Operatore" && a.push(o.uorId), a), []) ?? [];

            // in questo caso non va bene utilizzare abilityBuild perchè verifica se l'utente può eseguire
            // l'azione solo nella uor corrente, mentre l'utente può scegliere in quale uor
            // creare il protocollo

            if (uorIdWhereUserIsOperatore.length > 0) {
                newCommandBarItems.push({
                    key: 'createFrom',
                    text: 'Crea da',
                    iconProps: { iconName: 'Copy' },
                    onClick: (event) => {
                        let protocolId = selectedSingleProtocolAreaDiLavoro!.protocolId;
                        this.props.history.push({ pathname: `/${this.props.currentAoo?.id}/createfrom/${protocolId}`, search: this.props.location.search });
                    }
                });
            }


        }

        newFarBarItems.push(
            {
                key: 'globalSearchBox',
                commandBarButtonAs: () => (

                    <SearchBox
                        placeholder="Ricerca"
                        styles={globalSearchBoxStyles}
                        onSearch={searchValue => this.globalSearchSubmitHandler(searchValue)}
                        defaultValue={this.state.searchRequest?.globalSearch} />

                )
            }
        );

        this.setState({ commandBarItems: newCommandBarItems, farItems: newFarBarItems })
    }

    remapColumns = (columns: IColumn[]): IColumn[] => {
        columns = columns.map(el => {
            switch (el.key) {
                case 'visibilita':
                    return { ...el, onRenderField: this.onRenderVisibilitaField };
                case 'hasAttachments':
                    return {
                        ...el,
                        onRenderField: this.onRenderAttachmentField,
                        onRenderHeader: () => {
                            return <Icon iconName="Attach" className={classNames.iconFieldHeader} />;
                        }
                    };
                case 'annotazione':
                    return {
                        ...el,
                        onRenderField: this.onRenderAnnotazioneField,
                        onRenderHeader: () => {
                            return <Icon iconName="Message" className={classNames.fileIconHeaderIcon} />;
                        }
                    };
                case 'hasSummaryIAIcon':
                    return {
                        ...el,
                        onRenderField: this.onRenderHasSummaryIAField,
                        onRenderHeader: () => {
                            return <FontAwesomeIcon icon={{ prefix: 'fal', iconName: 'microchip-ai' }} className={classNames.fileIconHeaderIcon} />
                        }
                    };
                case 'statoProtocolloIcon':
                    return {
                        ...el,
                        onRenderField: this.onRenderStatoProtocolloField,
                        onRenderHeader: () => {
                            return <FontAwesomeIcon icon={{ prefix: 'fal', iconName: 'file-slash' }} className={classNames.fileIconHeaderIcon} />
                        }
                    };
                default:
                    return { ...el };
            }

        });
        return columns;
    }
    setColumns = (): IColumn[] => {

        let fields: IField[] = [...this.props.tuttiIProtocolliViewFields!];

        let _fields = fields.filter(f => !f.system
            && f.internalName !== 'ID'
            && f.internalName !== 'Title'
            && f.internalName !== 'Protocollo'
            && f.internalName !== 'Proprietario'
            && f.internalName !== 'CopiaConoscenza'
            && f.internalName !== 'Inoltro'
            && f.internalName !== 'Visibilita');

        let newColumns: IColumn[] = [
            {
                key: 'visibilita',
                name: 'visibilita',
                fieldName: 'visibilita',
                isIconOnly: true,
                styles: iconHeaderStyles,
                minWidth: 6,
                maxWidth: 6,
                onRenderField: this.onRenderVisibilitaField
            },
            {
                key: 'hasAttachments',
                name: 'hasAttachments',
                fieldName: 'hasAttachments',
                isIconOnly: true,
                styles: iconHeaderStyles,
                minWidth: 7,
                maxWidth: 7,
                onRenderField: this.onRenderAttachmentField,
                onRenderHeader: () => {
                    return <Icon iconName="Attach" className={classNames.iconFieldHeader} />
                },

            },
            {
                key: 'statoProtocolloIcon',
                name: 'statoProtocolloIcon',
                fieldName: 'StatoProtocollo',
                isIconOnly: true,
                styles: iconHeaderStyles,
                minWidth: 9,
                maxWidth: 9,
                onRenderField: this.onRenderStatoProtocolloField,
                onRenderHeader: () => {
                    return <FontAwesomeIcon icon={{ prefix: 'fal', iconName: 'file-slash' }} className={classNames.fileIconHeaderIcon} />
                }

            },
            {
                key: 'annotazione',
                name: 'annotazione',
                fieldName: 'annotazione',
                isIconOnly: true,
                styles: iconHeaderStyles,
                minWidth: 7,
                maxWidth: 7,
                onRenderField: this.onRenderAnnotazioneField,
                onRenderHeader: () => {
                    return <Icon iconName="Message" className={classNames.fileIconHeaderIcon} />
                }
            }
        ];
        if (abilityBuild.can('use', subject('IFeature', { key: 'IAAssistant', enabled: true }))) {
            newColumns.push({
                key: 'hasSummaryIAIcon',
                name: 'hasSummaryIAIcon',
                fieldName: 'hasSummaryIAIcon',
                isIconOnly: true,
                styles: iconHeaderStyles,
                minWidth: 9,
                maxWidth: 9,
                onRenderField: this.onRenderHasSummaryIAField,
                onRenderHeader: () => {
                    return <FontAwesomeIcon icon={{ prefix: 'fal', iconName: 'microchip-ai' }} className={classNames.fileIconHeaderIcon} />
                }
            })
        }
        newColumns.push({
            key: 'Protocollo',
            name: 'Protocollo',
            fieldName: 'Protocollo',
            minWidth: 110,
            maxWidth: 110,
            isResizable: true,
        });


        _fields.forEach(el => {
            const fieldFullProperties = this.props.tuttiIProtocolliViewFields?.find(it => it.internalName === el.internalName);
            const field = fieldFullProperties ? { ...fieldFullProperties } : { ...el };

            let col: IColumn = {
                key: field.internalName,
                fieldName: field.internalName,
                name: field.displayName,
                minWidth: 150,
                isResizable: true,
                ...field
            };
            if (field.internalName === 'DataProtocollo' || field.internalName === 'StatoProtocollo') {
                col.maxWidth = 110;
                col.minWidth = 110;
            } else if (field.internalName === "TipoProtocollo") {
                col.maxWidth = 140;
                col.minWidth = 140;
            }
            newColumns.push(col);
        });
        /// Aggiungo una colonna vuota in coda alla tabella, è necessaria per consentire l'allineamento tra
        /// l'header e i contenuti della tabella 
        if (!this.props.isMobile) {
            newColumns.push(
                {
                    key: 'empty',
                    name: 'empty',
                    fieldName: 'empty',
                    isIconOnly: true,

                    className: classNames.emptyColumn,
                    headerClassName: classNames.emptyColumn,
                    minWidth: 1,
                    maxWidth: 1,
                    onRender: (item) => { },
                },

            );
        }
        this.saveReduxState();
        return newColumns;

    }

    onRenderVisibilitaField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        if (columnProps && columnProps.item) {
            let item = columnProps.item
            let protocolId = item.id;
            let uorField = this.state.uorField;
            let visibilitaField = this.state.visibilitaField;
            const arrayVisibilita = item.visibilita;

            // se nella form ho selezionato un tipo di visibilità nella tabella uso l'icona relativa alla visibilità selezionata
            if (visibilitaField.internalValue !== undefined && visibilitaField.internalValue !== null) {
                return this.renderVisibilitaIconByType(visibilitaField.internalValue, protocolId);

            }
            // altrimenti se ho selezionato una uor utilizzo la visibilita che la uor selezionata ha sul protocollo
            else if (uorField.internalValue && uorField.internalValue.length > 0) {
                let uorId = uorField.internalValue[0].key;
                const visibilitaUor: IVisibilita = arrayVisibilita.find(r => r.uor.id === uorId);
                return this.renderVisibilitaIconByType(visibilitaUor?.tipologia, protocolId);

            }
            else {
                // Con questo metodo faccio il render dell'icona della visibilità che l'utente ha sul protocollo.
                // Visualizzo solo una delle visibilità che l'utente può avere, la più importante secondo questo ordine:
                // Proprietario, Inoltro, CopiaConoscenza, Visibilità
                if (item.visibilita) {
                    // ricavo i ruoli dell'utente corrente nell'aoo corrente
                    const ruoliUtenteCurrentAoo = this.props.currentUser?.ruoliUorContext.filter(r => r.aooId === this.props.currentAoo?.id);

                    // ricavo la uor proprietaria del protocollo
                    const proprietario = arrayVisibilita.find(r => r.tipologia === Visibility_Type.Proprietario);
                    if (proprietario !== undefined && ruoliUtenteCurrentAoo !== undefined) {
                        // se l'utente ha almeno un ruolo attivo nella uor proprietaria del protocollo
                        // faccio il render  dell'icona del proprietario
                        // altrimenti procedo con il check tra le uor in inoltro
                        const isUtenteProprietario = ruoliUtenteCurrentAoo.some(r => r.uorId === proprietario.uor.id);
                        if (isUtenteProprietario) {
                            return (<TableIconProprietario key={`visibilita-protocol-${protocolId}`} />);
                        }
                    }

                    // ricavo le uor che hanno il protocollo in inoltro 
                    const inoltri = arrayVisibilita.filter(r => r.tipologia === Visibility_Type.Inoltro);
                    if (inoltri !== undefined && ruoliUtenteCurrentAoo !== undefined) {
                        // se l'utente ha almeno un ruolo attivo in una delle uor che hanno il protocollo in inoltro
                        // faccio il render  dell'icona dell'inoltro
                        // altrimenti procedo con il check tra le uor in copia conoscenza
                        const isUtenteInInoltro = ruoliUtenteCurrentAoo.some(r => inoltri.some(v => v.uor.id === r.uorId));
                        if (isUtenteInInoltro) {
                            return (<TableIconInoltro key={`visibilita-protocol-${protocolId}`} />);
                        }
                    }

                    // ricavo le uor che hanno il protocollo in copia conoscenza 
                    const copiaConoscenza = arrayVisibilita.filter(r => r.tipologia === Visibility_Type.CopiaConoscenza);
                    if (copiaConoscenza !== undefined && ruoliUtenteCurrentAoo !== undefined) {
                        // se l'utente ha almeno un ruolo attivo in una delle uor che hanno il protocollo in copia conoscenza
                        // faccio il render  dell'icona della copia conoscenza
                        // altrimenti procedo con il check tra le uor in visibilità
                        const isUtenteInCopiaConoscenza = ruoliUtenteCurrentAoo.some(r => copiaConoscenza.some(v => v.uor.id === r.uorId));
                        if (isUtenteInCopiaConoscenza) {
                            return (<TableIconCopiaConoscenza key={`visibilita-protocol-${protocolId}`} />);
                        }
                    }
                    // ricavo le uor che hanno il protocollo in visibilità
                    const visibilita = arrayVisibilita.filter(r => r.tipologia === Visibility_Type.Visibilita);
                    if (visibilita !== undefined && ruoliUtenteCurrentAoo !== undefined) {
                        // se l'utente ha almeno un ruolo attivo in una delle uor che hanno il protocollo in cvisibilità
                        // faccio il render  dell'icona della visibilità
                        // altrimenti lascio la colonna vuota (caso supervisore)
                        const isUtenteInVisibilita = ruoliUtenteCurrentAoo.some(r => visibilita.some(v => v.uor.id === r.uorId));
                        if (isUtenteInVisibilita) {
                            return (<TableIconVisibilita key={`visibilita-protocol-${protocolId}`} />);
                        }
                    }
                }
            }
        }
        return <div className={classNames.iconField}></div>
    }
    private renderVisibilitaIconByType(visibilitaTipo: Visibility_Type, protocolId: number) {
        switch (visibilitaTipo) {

            case Visibility_Type.Proprietario:
                return (<TableIconProprietario key={`visibilita-protocol-${protocolId}`} />);

            case Visibility_Type.Inoltro:
                return (<TableIconInoltro key={`visibilita-protocol-${protocolId}`} />);

            case Visibility_Type.CopiaConoscenza:
                return (<TableIconCopiaConoscenza key={`visibilita-protocol-${protocolId}`} />);

            case Visibility_Type.Visibilita:
                return (<TableIconVisibilita key={`visibilita-protocol-${protocolId}`} />);
            default:
                return <div className={classNames.iconField} ></div>;
        }

    }



    onRenderAttachmentField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        if (columnProps && columnProps.item && columnProps.item.hasAttachments) {
            return (
                <div key={`attachment-protocol-${columnProps!.item!.id}`} className={classNames.iconField} >
                    <TooltipHost content="Allegato">
                        <Icon iconName="Attach" style={{ fontSize: 16 }} />
                    </TooltipHost>
                </div>);
        }
        return <div className={classNames.iconField} ></div>;
    }

    onRenderAnnotazioneField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        if (columnProps && columnProps.item && columnProps.item.hasNotes) {
            return (
                <div key={`annotation-protocol-${columnProps!.item!.id}`} className={classNames.iconField} >
                    <TooltipHost content="Annotazione">
                        <Icon iconName="Message" style={{ fontSize: 16 }} />
                    </TooltipHost>
                </div>);

        }
        return <div className={classNames.iconField} ></div>;
    }

    onRenderStatoProtocolloField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        if (columnProps && columnProps.item && columnProps.item.statoProtocollo === Protocol_State.Annullato) {
            return (
                <div key={`state-protocol-${columnProps!.item!.id}`} className={classNames.iconField} >
                    <TooltipHost content="Annullato">
                        <FontAwesomeIcon icon={{ prefix: 'fal', iconName: 'file-slash' }} style={{ fontSize: 16 }} />
                    </TooltipHost>
                </div>
            );

        }
        return <div className={classNames.iconField} ></div>;
    }

    onRenderHasSummaryIAField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        let iconContent: any = (<React.Fragment></React.Fragment>);
        if (columnProps && columnProps.item && columnProps.item.hasSummaryIA) {
            iconContent = (
                <FontAwesomeIcon id={`summary-ia-${columnProps!.item!.id}`}
                    icon={{ prefix: 'fal', iconName: 'microchip-ai' }}
                    style={{ fontSize: 16, cursor: 'pointer' }}
                    onClick={() => this.openSummaryIACallout(columnProps!.item!)} />
            );

        }
        return (
            <div key={`wrap-summary-ia-${columnProps!.item!.id}`} className={classNames.iconField} >
                <TooltipHost content="Analisi IA disponibile">
                    {iconContent}
                </TooltipHost>
            </div>
        );
    }

    getSearchFormFields = () => {
        let { match } = this.props;
        let aooId: number = Number(match.params['aooId']);

        // se in cancelTokenSources c'è il cancelToken associato alla chiamata
        // chiamo il metodo cancel che interrompe la chiamata in pending
        this.cancelTokenSources[fieldsService.getFieldsByViewName.name]?.cancel("Request annullata");
        // Ricreo il cancel token ad ogni request
        this.cancelTokenSources[fieldsService.getFieldsByViewName.name] = axios.CancelToken.source();

        fieldsService
            .getFieldsByViewName(aooId, "Campi ricerca", this.cancelTokenSources[fieldsService.getFieldsByViewName.name].token)
            .then(fields => {
                let fixedFields = this.removeHiddenProtocolCreationStates(
                    AppUtilities.fixFieldsForm(Indici_FormMode.Search, fields)
                );

                this.setState({
                    searchFormFields: fixedFields
                }, () => {
                    this.saveReduxState();
                });
                this.props.updateSession({ campiRicercaViewFields: fixedFields });

            })
            .catch(error => {
                if (axios.isCancel(error)) {
                    //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                    console.log(error.message);
                } else {
                    throw error;
                }
            });
        ;
    }


    globalSearchSubmitHandler = (searchValue) => {
        if (searchValue.trim().length >= 3) {
            let { searchFormFields, uorField, visibilitaField, searchRequest } = this.state;

            let newSearchFields = searchFormFields.map(el => {
                return { ...el, internalValue: null, touched: false };
            });

            let newSearchRequest: ISearchCriteria = {
                ...searchRequest,
                pageNumber: 1,
                globalSearch: searchValue,
                filters: []
            };

            this.setState({
                searchFormFields: newSearchFields,
                uorField: { ...uorField, internalValue: [] },
                visibilitaField: { ...visibilitaField, internalValue: null },
                items: [],
                totalRows: 0,
                searchResultMessage: '',
                searchRequest: newSearchRequest
            }, () => {
                this.saveReduxState();
                this.getProtocols();
            });

        } else {
            toastRef.current?.show({
                severity: 'warn',
                summary: 'Attenzione',
                detail: `Inserire almeno 3 caratteri per avviare la ricerca`,
                life: 3000
            });
        }
    }

    searchLookupSuggestions = async (filterText: string): Promise<ITag[]> => {
        let result: ITag[] = [];
        let { currentAoo } = this.props;
        if (currentAoo && filterText && filterText.length > 0) {
            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            this.cancelTokenSources[uorsService.getUorSuggestionsForCurrentUser.name]?.cancel("Request annullata");
            // Ricreo il cancel token ad ogni request
            this.cancelTokenSources[uorsService.getUorSuggestionsForCurrentUser.name] = axios.CancelToken.source();

            await uorsService.getUorSuggestionsForCurrentUser(currentAoo.id, filterText, this.cancelTokenSources[uorsService.getUorSuggestionsForCurrentUser.name].token)
                .then(suggestions => {
                    result = suggestions.reduce((a: ITag[], o) => (o && a.push({ key: o.id!, name: o.nome! }), a), [])
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    } else {
                        throw error;
                    }
                });
        }

        return result;

    }

    removeTagPickerDuplicates = (items: ITag[], possibleDupes: ITag[]) => {
        return items.filter(persona => possibleDupes.findIndex(el => el.key === persona.key) < 0);
    }

    onTagPickerFilterChanged = async (filterText: string, currentTags?: ITag[]): Promise<ITag[]> => {
        if (filterText) {
            let filteredSuggestions = await this.searchLookupSuggestions(filterText);

            if (currentTags)
                filteredSuggestions = this.removeTagPickerDuplicates(filteredSuggestions, currentTags);

            return filteredSuggestions;
        } else {
            return [];
        }
    };

    onTagSelected = (selectedItem: any): ITag | null => {
        // restituendo null il component non aggiunge nessun elemento alla selezione e riesco a controllare
        // gli elementi selezionati tramiteinputChanged(selectedItem) che setta l'internalValue del campo
        return selectedItem;
    }
    onTagPickerItemsChange = (items?: any[]): void => {
        this.setState({
            uorField: { ...this.state.uorField, internalValue: items }
        }, () => { this.saveReduxState() });
    };

    //metodi per selection visibilita
    onDropdownSelectChange = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
        if (option) {
            this.setState({
                visibilitaField: { ...this.state.visibilitaField, internalValue: option.key }
            }, () => { this.saveReduxState() });

        }
    }

    onCleanDropdownButton = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({
            visibilitaField: { ...this.state.visibilitaField, internalValue: null }
        }, () => { this.saveReduxState() });
    }

    onRenderDropodownTitle = (options: IDropdownOption<IVisibilita>[] | undefined): JSX.Element => {
        const option = options![0];

        return (
            <div>
                <span>{option.text}
                    <IconButton
                        iconProps={{ iconName: 'Cancel' }}
                        styles={{ root: { height: 20, width: 20, verticalAlign: 'text-top' } }}
                        onClick={this.onCleanDropdownButton} />
                </span>
            </div>
        );
    };

    openSearchPanel = (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({ searchPanelIsOpen: true })
    }

    dismissSearchPanel = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ searchPanelIsOpen: false })
    }
    openSummaryIACallout = (item: IProtocol) => {
        const { location, match, currentUser } = this.props;
        const aooId = Number(match.params['aooId']);
        const parsed = queryString.parse(location.search);

        const currentItem =
            this.state.items.find((el) => el && el.protocolId === item.protocolId) ?? item;

        if (currentUser) {

            let visibilitaProtocollo = currentItem.visibilita;
            let uorId: number | undefined = parsed.uorId ? Number(parsed.uorId) : undefined;

            if (uorId === undefined && visibilitaProtocollo) {

                uorId = this.getUorUtenteConVisibilitaPiuImportante(visibilitaProtocollo, currentUser, aooId);
            }

            this.setState({
                summaryIACalloutIsOpen: true,
                summaryIA: currentItem.summaryIA ?? undefined,
                summaryIAisLoading: !currentItem.summaryIA,
                summaryIACalloutTargetId: `summary-ia-${item.protocolId}`
            });

            if (currentItem.summaryIA || !currentItem.hasSummaryIA) return;

            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            this.cancelTokenSources[protocolsService.getSummaryIA.name]?.cancel(protocolsService.getSummaryIA.name + " Request annullata");
            // Ricreo il cancel token ad ogni request
            this.cancelTokenSources[protocolsService.getSummaryIA.name] = axios.CancelToken.source();

            this.setState({ summaryIAisLoading: true, summaryIA: undefined });
            protocolsService.getSummaryIA(aooId, uorId, item.protocolId!, this.cancelTokenSources[protocolsService.getSummaryIA.name].token)
                .then(summaryIA => {
                    this.setState((prev) => ({
                        summaryIA,
                        summaryIAisLoading: false,
                        items: prev.items.map((el) =>
                            el && el.protocolId === item.protocolId ? { ...el, summaryIA: summaryIA } : el
                        ),
                    }));
                })
                .catch(error => {
                    this.setState({
                        summaryIAisLoading: false
                    });

                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    } else if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Impossibile leggere l'elaborazione IA`, life: 5000 });

                    } else {
                        throw error;
                    }
                });
        }
    };

    dismissSummaryIACallout = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ summaryIACalloutIsOpen: false, summaryIACalloutTargetId: undefined, summaryIA: undefined })
    }

    onRenderDetailsHeader = (detailsHeaderProps) => {
        const detailsListHeadrerStyles: Partial<IDetailsListStyles> = {

            root: { boxSizing: 'content-box !important' }

        };
        return (

            <DetailsHeader
                {...detailsHeaderProps}
                styles={detailsListHeadrerStyles}
            />
        );
    }

    onRenderMissingItem = (): null => {
        if (this.state.isLoadingProtocols) {
            return null;
        }

        let currentItems = this.state.items.slice();
        currentItems.pop();

        this.setState({
            items: currentItems
        }, () => { this.getProtocols(); });

        return null;
    };

    private removeHiddenProtocolCreationStates = (fields: IField[]): IField[] => {
        return fields.map((field: IField) => {
            if (field.internalName !== 'StatoProtocollo' || field.controlType !== 'dropdown') {
                return field;
            }

            const choiceField = field as IChoiceField;
            const options = choiceField.options.filter((option: IDropdownOption) => {
                return !this.isHiddenProtocolCreationState(option.key) &&
                    !this.isHiddenProtocolCreationState(option.text);
            });
            const internalValue = this.isHiddenProtocolCreationState(choiceField.internalValue)
                ? null
                : choiceField.internalValue;

            return {
                ...choiceField,
                options,
                internalValue,
                touched: internalValue ? choiceField.touched : false
            };
        });
    }

    private isHiddenProtocolCreationState = (value: any): boolean => {
        return this.hiddenProtocolCreationStates.some((state: string) => state === value?.toString());
    }

    indiciInputChangedHandler = (newField: IField) => {

        const updatedFormFields: IField[] = [...this.state.searchFormFields];
        let itemIndex = updatedFormFields.findIndex(el => el.internalName === newField.internalName);
        // se l'internalValue è null setto field.touched a false così viene ignorato durante la ricerca
        if (!newField.internalValue) {
            updatedFormFields[itemIndex] = { ...newField, touched: false };
        } else {
            updatedFormFields[itemIndex] = { ...newField };
        }
        this.setState({
            searchFormFields: updatedFormFields
        }, () => { this.saveReduxState() });

    }

    onAggiornaProtocolliClick = () => {
        let currentSearchRequest: ISearchCriteria = {
            ...this.state.searchRequest,
            pageNumber: 1
        };

        if (!this.props.tuttiIProtocolliViewFields || this.props.tuttiIProtocolliViewFields.length === 0) {
            fieldsService.getFieldsByViewName(this.props.currentAoo!.id, 'Tutti i protocolli')
                .then(campi => {
                    this.props.updateSession({ tuttiIProtocolliViewFields: campi });
                    setTimeout(() => {
                        let columns = this.setColumns();
                        this.setState({
                            columns,
                            items: [],
                            totalRows: 0,
                            searchResultMessage: '',
                            searchRequest: currentSearchRequest,
                        }, () => {
                            this.getProtocols();
                        });
                    }, 100);
                })
                .catch(error => {
                    this.props.updateSession({ tuttiIProtocolliViewFields: [] });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: "Attenzione",
                            detail: "Non è stato possibile recuperare i campi dei protocolli. Aggiornare la pagina.",
                            life: 5000
                        });
                    }
                });
        } else {
            this.setState({
                items: [],
                totalRows: 0,
                searchResultMessage: '',
                searchRequest: currentSearchRequest,
            }, () => {
                this.getProtocols();
            });
        }
    }

    resetSearchHandler = () => {
        let { searchFormFields, uorField, visibilitaField, searchRequest } = this.state;

        let newSearchFields = searchFormFields.map(el => {
            return { ...el, internalValue: null, touched: false };
        });

        this.protocolSelection.setAllSelected(false);

        this.setState({
            searchFormFields: newSearchFields,
            uorField: { ...uorField, internalValue: [] },
            visibilitaField: { ...visibilitaField, internalValue: null },
            isLoadingProtocols: true,
            items: [],
            totalRows: 0,
            searchResultMessage: '',
            searchRequest: {
                ...searchRequest,
                pageNumber: 1,
                globalSearch: undefined,
                filters: []
            }
        }, () => {
            this.saveReduxState();
            this.getProtocols();
        });
    }

    resetSearchFields = () => {
        let { searchFormFields, uorField, visibilitaField } = this.state;

        let newSearchFields = searchFormFields.map(el => {
            return { ...el, internalValue: null, touched: false };
        });
        this.setState({
            searchFormFields: newSearchFields,
            uorField: { ...uorField, internalValue: [] },
            visibilitaField: { ...visibilitaField, internalValue: null }
        }, () => { this.saveReduxState() });
    }

    // Click su salva del panel laterale
    searchLateralPanelSubmit = () => {
        const filters = this.buildSearchFilters();

        this.setState(prevState => ({
            searchRequest: {
                ...prevState.searchRequest,
                globalSearch: undefined,
                pageNumber: 1,
                filters: filters
            },
            searchPanelIsOpen: false,
            isLoadingProtocols: true,
            items: [],
            totalRows: 0,
            searchResultMessage: '',
        }), () => {
            this.saveReduxState();
            this.getProtocols();
        });
    }

    onDownloadProtocolDocumentClick = () => {
        let { currentAoo, location, currentUser } = this.props;
        const parsedQueryString = queryString.parse(location.search);

        if (currentAoo && currentUser && this.state.selectedProtocols) {
            let { selectedProtocols } = this.state;
            let selectedSingleProtocolAreaDiLavoro: IProtocol | undefined = selectedProtocols.length === 1 ? selectedProtocols[0] : undefined;
            if (selectedSingleProtocolAreaDiLavoro) {

                let protocolId = selectedSingleProtocolAreaDiLavoro.protocolId!;
                let visibilitaProtocollo = selectedSingleProtocolAreaDiLavoro.visibilita;
                let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

                if (uorId === undefined && visibilitaProtocollo) {

                    uorId = this.getUorUtenteConVisibilitaPiuImportante(visibilitaProtocollo, currentUser, currentAoo.id);
                }

                // se in cancelTokenSources c'è il cancelToken associato alla chiamata
                // chiamo il metodo cancel che interrompe la chiamata in pending
                this.cancelTokenSources[protocolsService.getProtocolDocumentFile.name]?.cancel(protocolsService.getProtocolDocumentFile.name + " Request annullata");
                // Ricreo il cancel token ad ogni request
                this.cancelTokenSources[protocolsService.getProtocolDocumentFile.name] = axios.CancelToken.source();

                toastRef.current?.show({ severity: 'info', summary: 'Informazione', detail: `Avviato il download del documento`, life: 5000 });

                protocolsService
                    .getProtocolDocumentFile(currentAoo.id, uorId, protocolId, this.cancelTokenSources[protocolsService.getProtocolDocumentFile.name].token)
                    .then(documentFile => {
                        const saveResult = Utilities.SaveFile(documentFile);

                        if (saveResult.ok) {
                            toastRef.current?.show({ severity: 'info', summary: 'Informazione', detail: `Download del documento completato con successo`, life: 5000 });
                        } else {
                            toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Impossibile completare il download del documento`, life: 5000 });
                            console.error("Download", "SaveFile result:", saveResult);
                        }
                    })
                    .catch(error => {

                        if (axios.isCancel(error)) {
                            //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                            console.log(error.message);
                        } else if (!error.isErrorShown) {
                            toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Impossibile completare il download del documento`, life: 5000 });

                        } else {
                            throw error;
                        }

                    });
            }
        };
    }

    onDownloadAllButtonClick = () => {
        let { currentAoo, location, currentUser } = this.props;
        const parsedQueryString = queryString.parse(location.search);

        if (currentAoo && currentUser && this.state.selectedProtocols) {
            let { selectedProtocols } = this.state;
            let selectedSingleProtocolAreaDiLavoro: IProtocol | undefined = selectedProtocols.length === 1 ? selectedProtocols[0] : undefined;
            if (selectedSingleProtocolAreaDiLavoro) {

                let protocolId = selectedSingleProtocolAreaDiLavoro.protocolId!;
                let visibilitaProtocollo = selectedSingleProtocolAreaDiLavoro.visibilita;
                let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

                if (uorId === undefined && visibilitaProtocollo) {

                    uorId = this.getUorUtenteConVisibilitaPiuImportante(visibilitaProtocollo, currentUser, currentAoo.id);
                }

                // se in cancelTokenSources c'è il cancelToken associato alla chiamata
                // chiamo il metodo cancel che interrompe la chiamata in pending
                this.cancelTokenSources[protocolsService.getProtocolFilesAsZip.name]?.cancel(protocolsService.getProtocolFilesAsZip.name + " Request annullata");
                // Ricreo il cancel token ad ogni request
                this.cancelTokenSources[protocolsService.getProtocolFilesAsZip.name] = axios.CancelToken.source();

                toastRef.current?.show({ severity: 'info', summary: 'Informazione', detail: `Avviato il download degli allegati`, life: 5000 });

                protocolsService
                    .getProtocolFilesAsZip(currentAoo.id, uorId, protocolId, this.cancelTokenSources[protocolsService.getProtocolFilesAsZip.name].token)
                    .then(zipFile => {
                        const saveResult = Utilities.SaveFile(zipFile, zipFile?.fileName);

                        if (saveResult.ok) {
                            toastRef.current?.show({ severity: 'info', summary: 'Informazione', detail: `Download degli allegati completato con successo`, life: 5000 });
                        } else {
                            toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Impossibile completare il download degli allegati`, life: 5000 });
                            console.error("Download", "SaveFile result:", saveResult);
                        }
                    })
                    .catch(error => {

                        if (axios.isCancel(error)) {
                            //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                            console.log(error.message);
                        } else if (!error.isErrorShown) {
                            toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Impossibile completare il download degli allegati`, life: 5000 });

                        } else {
                            throw error;
                        }

                    });
            }
        };
    }

    getUorUtenteConVisibilitaPiuImportante = (visibilitaProtocollo: IVisibilita[], currentUser: IUserInfoDTO, currentAooId: number): number | undefined => {
        // Questo metodo determina la UOR con la visibilità più alta a cui l'utente ha accesso.
        // L'ordine di importanza della visibilità è: Proprietario, Inoltro, CopiaConoscenza, Visibilità.


        // ricavo le uor in cui l'utente corrente ha almeno un ruolo 
        const uorIdWhereUserHasAnyUorContextRole = currentUser?.ruoliUorContext.reduce((a: number[], o) => (o.aooId === currentAooId && a.push(o.uorId), a), []) ?? [];

        if (uorIdWhereUserHasAnyUorContextRole) {
            // Ottengo la UOR proprietaria del protocollo se è presente tra le UOR in cui l'utente ha un ruolo.   
            const proprietario = visibilitaProtocollo.find(
                vis => vis.tipologia === Visibility_Type.Proprietario
                    && uorIdWhereUserHasAnyUorContextRole.some(r => r === vis.uor.id)
            );

            if (proprietario !== undefined) {
                return proprietario.uor.id
            }


            // Ottengo la prima UOR in inoltro se è presente tra le UOR in cui l'utente ha un ruolo.   
            const inoltro = visibilitaProtocollo.find(
                vis => vis.tipologia === Visibility_Type.Inoltro
                    && uorIdWhereUserHasAnyUorContextRole.some(r => r === vis.uor.id)
            );
            if (inoltro !== undefined) {
                return inoltro.uor.id
            }


            // Ottengo la prima UOR in copia conoscenza se è presente tra le UOR in cui l'utente ha un ruolo.
            const copiaConoscenza = visibilitaProtocollo.find(
                vis => vis.tipologia === Visibility_Type.CopiaConoscenza
                    && uorIdWhereUserHasAnyUorContextRole.some(r => r === vis.uor.id)
            );
            if (copiaConoscenza !== undefined) {
                return copiaConoscenza.uor.id
            }

            // Ottengo la prima UOR in visibilità se è presente tra le UOR in cui l'utente ha un ruolo.
            const visibilita = visibilitaProtocollo.find(
                vis => vis.tipologia === Visibility_Type.Visibilita
                    && uorIdWhereUserHasAnyUorContextRole.some(r => r === vis.uor.id)
            );
            if (visibilita !== undefined) {
                return visibilita.uor.id
            }
        }
        return undefined;
    }

    dismissMessageBar = () => {
        this.setState({ messageBarIsVisible: false })
    }

    navigate = (ev, item?: IProtocol) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        if (item && item.protocolId) {
            this.props.setProtocol(item!);

            //aggiunge gli zeri prima del numero
            const zeroPad = (num, places) => String(num).padStart(places, '0');
            let protocolnumber = zeroPad(item.numeroProtocollo, 8) + '-' + item.annoProtocollo;

            let proprietario = item.visibilita!.find(v => v.tipologia === Visibility_Type.Proprietario);
            let uorIdProprietario = proprietario?.uor.id;


            let _pathname;
            let _search = this.props.location.search;
            let _parsedQueryString;
            switch (item.statoProtocollo) {
                case Protocol_State.Protocollato:
                case Protocol_State.Acquisito:
                case Protocol_State.Annullato:
                    _pathname = `/${this.props.currentAoo!.id}/${item.protocolId}/${protocolnumber}`;
                    break;
                case Protocol_State.Allocato:
                    _pathname = `/${this.props.currentAoo!.id}/allocated/${item.protocolId}/${protocolnumber}`;
                    _parsedQueryString = queryString.parse(_search);
                    _parsedQueryString.uorId = uorIdProprietario;
                    _search = queryString.stringify(_parsedQueryString);

                    break;
                case Protocol_State.InCreazione:
                case Protocol_State.InCreazioneDaMail:
                    _pathname = `/${this.props.currentAoo!.id}/edit/${item.protocolId}`;
                    _parsedQueryString = queryString.parse(_search);
                    _parsedQueryString.uorId = uorIdProprietario;
                    _search = queryString.stringify(_parsedQueryString);

                    break;

            }
            this.props.history.push({ pathname: _pathname, search: _search });
        }
    }

    onSelectProtocolHandler = (selected) => {
        this.setState({
            selectedProtocols: selected
        })
    }

    onRenderItemColumn = (protocol?: IProtocol, index?: number | undefined, column?: IColumn): React.ReactNode => {
        let fieldName = column?.fieldName;

        if (!protocol || !fieldName) {
            return this.buildDefaultCellRenderData(this.EMPTY_VALUE);
        }

        if (fieldName === "Protocollo") {
            return this.buildProtocolCellRenderData(protocol);
        }

        const fieldValue = protocol.fields?.find(f => f.internalName === fieldName);
        if (!fieldValue) {
            return this.buildDefaultCellRenderData(this.EMPTY_VALUE);
        }

        const fieldForDisplay = {
            ...column,
            internalValue: fieldValue.internalValue
        } as IField;

        const displayValue = AppUtilities.getDisplayValueFromFieldControlType(fieldForDisplay) || this.EMPTY_VALUE;
        return this.buildDefaultCellRenderData(displayValue);

    }

    buildDefaultCellRenderData = (value: string): React.ReactNode => {
        const tooltipProps = {
            content: value,
            styles: tooltipHostStyles,
            overflowMode: TooltipOverflowMode.Self
        };
        return (
            <TooltipHost {...tooltipProps}>
                {value}
            </TooltipHost>
        );
    };


    buildProtocolCellRenderData = (protocol: IProtocol): React.ReactNode => {
        let protocolText: string = AppUtilities.GetProtocolText(protocol);
        const tooltipProps = {
            content: protocolText,
            styles: tooltipHostStyles,
            overflowMode: TooltipOverflowMode.Self
        };

        return (
            <TooltipHost {...tooltipProps}>
                <Link key={`link-protocol-${protocol.protocolId}`} onClick={(ev) => this.navigate(ev, protocol)} >
                    {protocolText}
                </Link>
            </TooltipHost>
        );
    }

    onRenderLateralPanelFooterContent = () => {
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text="Cerca"
                    onClick={this.searchLateralPanelSubmit}

                />
                <DefaultButton
                    onClick={() => this.resetSearchFields()}
                    text="Reset filtri"
                />
            </React.Fragment>
        );
    }

    // metodi gestione context menu 
    onShowContextualMenu = (item, index, ev) => {
        ev.preventDefault();
        let { currentUser, match } = this.props;
        let aooId: number = Number(match.params['aooId']);

        const menuItems: IContextualMenuItem[] = [
            {
                key: 'open',
                text: 'Apri documento',
                iconProps: { iconName: 'Document' },
                onClick: () => {
                    this.navigate(ev, item);
                    this.onHideContextualMenu();
                }
            },
        ];

        if (item.hasAttachments) {
            menuItems.push({
                key: 'downloadDocument',
                text: 'Scarica',
                iconProps: { iconName: 'DownloadDocument' },
                split: true,
                onClick: () => {
                    this.onDownloadProtocolDocumentClick();
                    this.onHideContextualMenu();
                },
                subMenuProps: {
                    items: [
                        {
                            key: 'downloadAll',
                            text: 'Scarica tutto',
                            iconProps: { iconName: 'Download' },
                            onClick: () => {
                                this.onDownloadAllButtonClick();
                                this.onHideContextualMenu();
                            }
                        },
                    ],
                }

            });

        }
        else {
            menuItems.push({
                key: 'downloadDocument',
                text: 'Scarica',
                iconProps: { iconName: 'DownloadDocument' },
                onClick: () => {
                    this.onDownloadProtocolDocumentClick();
                    this.onHideContextualMenu();
                }
            });
        }


        // ricavo le uor in cui l'utente corrente ha ruolo Operatore
        const uorIdWhereUserIsOperatore = currentUser?.ruoliUorContext.reduce((a: number[], o) => (o.aooId === aooId && o.ruoloNome === "Operatore" && a.push(o.uorId), a), []) ?? [];

        // in questo caso non va bene utilizzare abilityBuild perchè verifica se l'utente può eseguire
        // l'azione solo nella uor corrente, mentre l'utente può scegliere in quale uor
        // creare il protocollo

        if (uorIdWhereUserIsOperatore.length > 0) {
            menuItems.push(
                {
                    key: 'createFrom',
                    text: 'Crea da',
                    iconProps: { iconName: 'Copy' },
                    onClick: (event) => {
                        let protocolId = item!.protocolId;
                        this.props.history.push({ pathname: `/${this.props.currentAoo?.id}/createfrom/${protocolId}`, search: this.props.location.search });
                    }
                }
            );
        }


        this.setState({ contextMenuItems: menuItems, showContextualMenu: true, contextMenuPosition: ev });
    };

    onHideContextualMenu = () => {
        this.setState({ contextMenuItems: undefined, showContextualMenu: false });
    };


    private removeNullPlaceholders = (items: (IProtocol | null)[]): IProtocol[] => {
        return items.filter((item): item is IProtocol => item !== null);
    }
    private mapVisibilityTypeToFilterValue = (value: any): string | undefined => {
        switch (value) {
            case Visibility_Type.Proprietario:
                return 'Proprietario';
            case Visibility_Type.Inoltro:
                return 'Inoltro';
            case Visibility_Type.CopiaConoscenza:
                return 'CopiaConoscenza';
            case Visibility_Type.Visibilita:
                return 'Visibilita';
            default:
                return undefined;
        }
    }
    private buildSearchFilters = (): ISearchFilter[] => {
        const touchedFields: IField[] = this.state.searchFormFields.filter(
            (el: IField) => el.touched && el.internalValue
        );

        const fixedFields = AppUtilities.fixFieldsInternalValueForSearchSubmit([...touchedFields]);

        const filters: ISearchFilter[] = fixedFields.map(field => ({
            internalName: field.internalName,
            value: field.internalValue
        }));

        if (this.state.uorField.internalValue && this.state.uorField.internalValue.length > 0) {
            filters.push({
                internalName: SearchFilterNames.UorId,
                value: this.state.uorField.internalValue[0].key
            });
        }

        const visibilitaTipo = this.mapVisibilityTypeToFilterValue(this.state.visibilitaField.internalValue);
        if (visibilitaTipo) {
            filters.push({
                internalName: SearchFilterNames.VisibilitaTipo,
                value: visibilitaTipo
            });
        }

        return filters;
    }


    public render() {

        return (
            <div className="search-component">
                <CircleLoader loaderClass='loader-large' loading={this.state.isLoadingProtocols} />

                <CommandBar
                    overflowButtonProps={overflowProps}
                    items={this.state.commandBarItems}
                    farItems={this.state.farItems}
                    styles={commandBarStyles}

                />
                {(this.state.searchResultMessage) &&
                    <Text block style={{ padding: "13px 25px 13px 29px" }}>{this.state.searchResultMessage}</Text>
                }


                {this.state.items.length > 0 &&
                    <DetailsList
                        className="with-empty-column"
                        styles={detailsListStyles}
                        componentRef={this.detailsListRef}
                        items={this.state.items}
                        columns={this.state.columns}
                        onRenderItemColumn={this.onRenderItemColumn}
                        onRenderDetailsHeader={this.onRenderDetailsHeader}
                        onRenderMissingItem={this.onRenderMissingItem}
                        layoutMode={DetailsListLayoutMode.justified}
                        selection={this.protocolSelection}
                        selectionPreservedOnEmptyClick={true}
                        selectionMode={SelectionMode.single}
                        checkboxVisibility={CheckboxVisibility.onHover}
                        onItemContextMenu={this.onShowContextualMenu}
                    />
                }
                {this.state.items.length === 0 &&

                    <Text block style={{ padding: 25 }}>Nessun risultato trovato.</Text>
                }

                <ContextualMenu
                    items={this.state.contextMenuItems!}
                    hidden={!this.state.showContextualMenu}
                    target={this.state.contextMenuPosition}
                    onItemClick={this.onHideContextualMenu}
                    onDismiss={this.onHideContextualMenu}
                />

                <Panel
                    isLightDismiss
                    isOpen={this.state.searchPanelIsOpen}
                    type={PanelType.custom}
                    customWidth={'600px'}
                    headerText={'Filtri di ricerca'}
                    id={'searchFormPanel'}  // l'ID 'searchFormPanel' viene usato nel component INPUT per gestire il click esterno al calendario
                    onDismiss={this.dismissSearchPanel}
                    onRenderFooterContent={this.onRenderLateralPanelFooterContent}

                    closeButtonAriaLabel="Close"
                    isHiddenOnDismiss={false}
                >
                    {this.state.messageBarIsVisible &&
                        <MessageBar
                            messageBarType={this.state.messageBarType}
                            isMultiline={false}
                            onDismiss={this.dismissMessageBar}
                            dismissButtonAriaLabel="Close">{this.state.messageBarText}</MessageBar>
                    }


                    <div className={`search-form-dialog flex flex-column position-relative`}>

                        <div className={this.state.uorField.touched && !this.state.uorField.valid ? 'field error' : 'field'}>
                            <Label className='field-label' htmlFor={this.state.uorField.internalName} required={this.state.uorField.required}>{this.state.uorField.displayName}</Label>
                            <TagPicker styles={{ root: { paddingBottom: '20px' } }}
                                key={this.state.uorField.internalName}
                                componentRef={this.tagPickerRef}
                                getTextFromItem={getTextFromTagItem}
                                selectedItems={this.state.uorField.internalValue}
                                itemLimit={1}
                                pickerSuggestionsProps={tagPickerSuggestionsProps}

                                onResolveSuggestions={this.onTagPickerFilterChanged}
                                onItemSelected={this.onTagSelected}
                                onChange={this.onTagPickerItemsChange}
                                resolveDelay={400}
                            />
                            <Label className='field-label' htmlFor={this.state.visibilitaField.internalName} required={this.state.visibilitaField.required}>{this.state.visibilitaField.displayName}</Label>
                            <Dropdown
                                key={this.state.visibilitaField.internalName}
                                disabled={false}
                                placeholder="Seleziona un elemento"
                                options={this.state.visibilitaField.options!}
                                selectedKey={this.state.visibilitaField.internalValue}
                                onChange={this.onDropdownSelectChange}
                                onRenderTitle={this.onRenderDropodownTitle}
                                styles={{ root: { paddingBottom: '20px' } }}
                            />
                            <DynamicForm
                                fields={this.state.searchFormFields}
                                onInputChangedHandler={(newField) => { this.indiciInputChangedHandler(newField) }}
                                formMode={Indici_FormMode.Search}
                            />

                            {this.state.uorField.touched && !this.state.uorField.valid && <span className="error-message">Campo obbligatorio</span>}
                        </div>


                    </div>

                </Panel>

                <SummaryIACallout
                    isOpen={this.state.summaryIACalloutIsOpen}
                    targetId={this.state.summaryIACalloutTargetId}
                    summaryIA={this.state.summaryIA}
                    isLoading={this.state.summaryIAisLoading}
                    onDismiss={this.dismissSummaryIACallout}
                />


            </div>

        );
    }

}



export default connector(withRouter(checkRoles(SearchComponentBase, RoleContext.Aoo)));




function getTextFromTagItem(tag: ITag): string {
    return tag.name as string;
}
